// extracted by mini-css-extract-plugin
module.exports = {"header":"FaHeaders_header__2WwUL","syncBtn":"FaHeaders_syncBtn__2IwBF","rightSection":"FaHeaders_rightSection__3CPAM","contentWrapper":"FaHeaders_contentWrapper__tKWcQ"};